var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGenero = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "DF360750-FF03-4DF7-9C1F-4435BF91AB28")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-21.000000, -166.000000)",
    fill: "#4B4B4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Copy-2",
    transform: "translate(0.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Menu-/-Banners",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 C11.3284271,-1.52179594e-16 12,0.671572875 12,1.5 L12,18.5 C12,19.3284271 11.3284271,20 10.5,20 L9.5,20 C8.67157288,20 8,19.3284271 8,18.5 L8,1.5 C8,0.671572875 8.67157288,1.52179594e-16 9.5,0 L10.5,0 Z M17.5,3 C18.3284271,3 19,3.67157288 19,4.5 L19,15.5 C19,16.3284271 18.3284271,17 17.5,17 L16.5,17 C15.6715729,17 15,16.3284271 15,15.5 L15,4.5 C15,3.67157288 15.6715729,3 16.5,3 L17.5,3 Z M3.5,3 C4.32842712,3 5,3.67157288 5,4.5 L5,8.5 C5,9.32842712 4.32842712,10 3.5,10 L2.5,10 C1.67157288,10 1,9.32842712 1,8.5 L1,4.5 C1,3.67157288 1.67157288,3 2.5,3 L3.5,3 Z",
    id: "Combined-Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGenero, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/genero.92e7ae12.svg";
export { ForwardRef as ReactComponent };